import React, { useContext } from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";
import { password_auth } from "config";
import { publicRoutes, privateRoutes, Error404, Maintenance } from "./routes";
import { maintenance, main_links } from "../config";
import { AuthContext } from "../auth/AuthContext";

const Routes = () => {
    if (password_auth.is_active) {
        /* VALIDACION DE CLAVE PARA INGRESAR */
        if (localStorage.getItem("password")) {
            const evalPass = JSON.parse(localStorage.getItem("password"));
            if (
                Math.round(
                    (new Date().getTime() - evalPass.time) / (1000 * 60 * 60)
                ) >= 1
            )
                localStorage.removeItem("password");
        }
        if (!localStorage.getItem("password")) {
            const secretPass = prompt(
                "Ingresa la constraseña para poder continuar"
            );
            if (password_auth.authorization.includes(secretPass)) {
                const authorized = {
                    time: new Date().getTime(),
                };
                localStorage.setItem("password", JSON.stringify(authorized));
            } else {
                window.top.location.href = password_auth.redirect_to;
                return;
            }
        }
        /* VALIDACION DE CLAVE PARA INGRESAR */
    }

    const { sessionData } = useContext(AuthContext);

    return (
        <Router>
            <Switch>
                {publicRoutes.map((route, i) => (
                    <Route
                        exact
                        key={i}
                        path={route.path}
                        render={(props) =>
                            maintenance.is_active ? (
                                <Maintenance {...props} />
                            ) : !sessionData.logged ? (
                                <route.component {...props} />
                            ) : (
                                <Redirect to={main_links.main_logged} />
                            )
                        }
                    />
                ))}

                {privateRoutes.map((route, i) => (
                    <Route
                        exact
                        key={i}
                        path={route.path}
                        render={(props) =>
                            sessionData.logged ? (
                                <route.component {...props} />
                            ) : (
                                <Redirect to={main_links.main} />
                            )
                        }
                    />
                ))}
                <Route render={(props) => <Error404 {...props} />} />
            </Switch>
        </Router>
    );
};

export default Routes;
